import { Component } from 'react';
import { connect } from 'react-redux';

class StudentDashboardComponent extends Component {

    render() {
        return (
            <div>
                <h3>TEAM LMS Platformuna Hoşgeldiniz!</h3>
                <p>
                    Merhaba {this.props.authenticatedUser.name} {this.props.authenticatedUser.surname},
                </p>
                <p>
                    TEAM LMS platformunda öğretmeninizin size ilettiklerine ulaşabilirsiniz.
                </p>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        authenticatedUser: state.authenticatedUser,
        mainPageTitle: state.mainPageTitle
    }
};

export default connect(mapStateToProps)(StudentDashboardComponent);